var map = {
	"./Adobe-logo.png": 5397,
	"./Angular-logo-1.png": 8930,
	"./Azure_Microsoft_Logo.svg.png": 8112,
	"./Bamboo@2x-blue.png": 5452,
	"./Bitbucket-Logo.wine.png": 2370,
	"./C++_ISO_Logo.svg.png": 452,
	"./CFF_Logo_vertical_RGB.png": 7509,
	"./Concourse-ci-ar21.png": 9429,
	"./Docker-logo.png": 14,
	"./Drogon-logo.png": 8191,
	"./Elasticsearch-logo.webp": 1585,
	"./Figma-logo.png": 3379,
	"./GiTlab-lOGO.png": 936,
	"./Google-cloud-platform.png": 424,
	"./Helm-icon-color.png": 417,
	"./Hetzner-logo-clear-space.png": 5641,
	"./JHipster_V2.png": 8792,
	"./Java-Logo.png": 4313,
	"./Jenkins_logo_with_title.svg.png": 6389,
	"./Jira-Logo.png": 4514,
	"./Kubernetes-Logo.png": 3579,
	"./Node.js_logo.svg.png": 7721,
	"./React-Logo-1.png": 3181,
	"./Sonarqube.png": 5761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6780;